import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { RepartiteurService } from "src/app/mon-portefeuille/core/service/repartiteur.service";

@Component({
  selector: "app-detenteur",
  templateUrl: "./detenteur.component.html",
  styleUrls: ["./detenteur.component.scss"],
})
export class DetenteurComponent implements OnInit {
  @Input() requestId;

  employees: Employee[];

  constructor(
    public activeModal: NgbActiveModal,
    private _repartiteurService: RepartiteurService
  ) {}

  ngOnInit() {
    this.getDetenteur(this.requestId);
  }

  getDetenteur(requestId) {
    this._repartiteurService.getDetenteur(requestId).subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
